import React, { useState } from "react";
import { Box, Chip, Grid, Stack, Typography } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

interface QuarterType {
  quarterName: string;
  docLink: string;
}

interface Programs {
  year: string;
  quarter: QuarterType[];
}

const programeList: Array<Programs> = [
  {
    year: "2025",
    quarter: [
      {
        quarterName: "First Quarter",
        docLink: "#",
      },
      {
        quarterName: "Second Quarter",
        docLink: "#",
      },
      {
        quarterName: "Third Quarter",
        docLink: "#",
      },
      {
        quarterName: "Fourth Quarter",
        docLink: "#",
      },
    ],
  },
  {
    year: "2024",
    quarter: [
      {
        quarterName: "First Quarter",
        docLink: "#",
      },
      {
        quarterName: "Second Quarter",
        docLink: "#",
      },
      {
        quarterName: "Third Quarter",
        docLink: "#",
      },
      {
        quarterName: "Fourth Quarter",
        docLink: "#",
      },
    ],
  },
  {
    year: "2023",
    quarter: [
      {
        quarterName: "First Quarter",
        docLink: "#",
      },
      {
        quarterName: "Second Quarter",
        docLink: "#",
      },
      {
        quarterName: "Third Quarter",
        docLink: "#",
      },
      {
        quarterName: "Fourth Quarter",
        docLink: "#",
      },
    ],
  },
  {
    year: "2022",
    quarter: [
      {
        quarterName: "First Quarter",
        docLink: "#",
      },
      {
        quarterName: "Second Quarter",
        docLink: "#",
      },
      {
        quarterName: "Third Quarter",
        docLink: "#",
      },
      {
        quarterName: "Fourth Quarter",
        docLink: "#",
      },
    ],
  },
  {
    year: "2021",
    quarter: [
      {
        quarterName: "First Quarter",
        docLink: "#",
      },
      {
        quarterName: "Second Quarter",
        docLink: "#",
      },
      {
        quarterName: "Third Quarter",
        docLink: "#",
      },
      {
        quarterName: "Fourth Quarter",
        docLink: "#",
      },
    ],
  },
  {
    year: "2020",
    quarter: [
      {
        quarterName: "First Quarter",
        docLink: "#",
      },
      {
        quarterName: "Second Quarter",
        docLink: "#",
      },
      {
        quarterName: "Third Quarter",
        docLink: "#",
      },
      {
        quarterName: "Fourth Quarter",
        docLink: "#",
      },
    ],
  },
];

const MentorshipProgramme = () => {
  const [selectedYear, setSelectedYear] = useState<string | "">("");
  const [selectedSubTab, setSelectedSubTab] = useState<string | "">("");

  const handleYearClick = (year: string) => {
    if (selectedYear === year) {
      setSelectedYear("");
    } else {
      setSelectedYear(year);
    }
  };

  function Subtabs(tabDetails: { subTabName: string; docLink: string }) {
    return (
      <Grid item key={tabDetails?.subTabName} xs="auto" sx={{ my: 1 }}>
        <a href={tabDetails.docLink} target="_blank">
          <Chip
            label={tabDetails?.subTabName}
            variant="filled"
            sx={{
              color:
                tabDetails?.subTabName === selectedSubTab
                  ? "secondary.main"
                  : "white",
              backgroundColor:
                tabDetails?.subTabName === selectedSubTab
                  ? "transparent"
                  : "secondary.main",
              cursor: "pointer",
              border: "2px solid",
              padding: "8px 16px",
              borderRadius: "16px",
              textTransform: "uppercase",
              fontWeight: "bold",
              transition: "all 0.3s ease-in-out",
              "&:hover": {
                opacity: 0.8,
                color: "inherit",
                backgroundColor: "transparent",
                border: "2px solid",
                borderColor: "secondary.main",
                "& .MuiChip-label": {
                  textDecoration: "underline",
                },
              },
              "&:active": {
                transform: "scale(0.95)",
              },
            }}
          />
        </a>
      </Grid>
    );
  }

  return (
    <>
      <Box
        sx={{
          backgroundColor: "primary.light",
          p: { xs: 1, md: 3 },
          width: "90vw",
        }}
        m={2}
      >
        <Stack
          direction="column"
          alignItems="flex-start"
          justifyContent="center"
          sx={{ border: "1px solid #e0e0e0", p: { xs: 1, md: 3 } }}
          spacing={2}
        >
          <Grid xs={12} p={2}>
            <Typography fontSize={16}>
              Modern College of Physiotherapy recognizes the significance of
              holistic student development and has implemented a robust
              Mentor-Mentee program. This initiative pairs faculty members
              (mentors) with junior students (mentees) to foster a supportive
              and nurturing learning environment. Mentors provide guidance,
              academic support, career counselling, and personal advice to their
              mentees. The program aims to facilitate smooth academic
              transitions, enhance interpersonal skills, and build a strong
              sense of belonging among students. Through regular interactions,
              mentors help mentees navigate challenges, explore career options,
              and achieve their academic and personal goals. This program serves
              as a valuable resource for students, contributing to their overall
              growth and success.
            </Typography>
          </Grid>
          {programeList?.map((item, idx) => {
            return (
              <Box key={idx} sx={{ width: "100%" }}>
                <Grid container alignItems={"center"}>
                  <Grid
                    sx={{
                      fontSize: 24,
                      transform: `rotate(${
                        item.year === selectedYear ? 90 : 0
                      }deg)`,
                    }}
                  >
                    {/* <ArrowForwardIosIcon /> */}
                  </Grid>
                  {/* <Grid>
                    <Typography
                      onClick={() => handleYearClick(item.year)}
                      sx={{
                        display: "block",
                        cursor: "pointer",
                        fontWeight: "bold",
                        fontSize: 16,
                        textDecoration: "none",
                        "&:hover": {
                          textDecoration: "underline",
                          color: "primary.main",
                        },
                        ml: 1,
                      }}
                    >
                      {item.year}
                    </Typography>
                  </Grid> */}
                </Grid>
                {/* {selectedYear === item.year && (
                  <Stack direction="column" sx={{ pl: 3 }}>
                    <Grid container spacing={2} marginY={3}>
                      {item.quarter?.map((subtab, subIdx) => {
                        const tabData = {
                          subTabName: Object.values(subtab)[0] as string,
                          docLink: subtab.docLink,
                        };
                        return (
                          <React.Fragment key={subIdx}>
                            {Subtabs(tabData)}
                          </React.Fragment>
                        );
                      })}
                    </Grid>
                  </Stack>
                )} */}
              </Box>
            );
          })}
        </Stack>
      </Box>
    </>
  );
};

export default MentorshipProgramme;
